type provider = {
    id: 'cdek' | 'boxberry' | 'ozon';
    name: 'Cdek' | 'Boxberry' | 'Ozon'
};

export const PvzProviderList: provider[] = [
    { id: 'cdek', name: 'Cdek', },
    { id: 'boxberry', name: 'Boxberry', },
    { id: 'ozon', name: 'Ozon', }
];